import { useUserInfoStore } from '@/modules/login/store/userInfo';
import { apiGatewayClient } from '@/common/apis/client';
import { ServerStateKeysEnum } from '@/common/apis/serverStateKeysEnum';
import { useQuery } from '@tanstack/react-query';

/** @deprecated factor uses v2 snapshot; v1 still accepts this query */
export const FACTOR_BALANCE_SOURCE = 'user_accounts';
export const FACTOR_BALANCE_VERSION = 'v2' as const;

type GetBalanceParams = {
  source?: string;
  version?: 'v1' | 'v2';
};

export const getBalance = async (params?: GetBalanceParams) => {
  const isV2 = params?.version === 'v2';
  const path = isV2 ? `/katibe/v2/transactions/balance/p24` : `/katibe/v1/transactions/balance/p24`;
  const query = isV2 ? undefined : params?.source ? { source: params.source } : undefined;
  return apiGatewayClient.get(path, {
    withCredentials: true,
    params: query,
  });
};

export const useGetBalance = (options?: any) => {
  const isLogin = useUserInfoStore(state => state.isLogin);
  const userId = useUserInfoStore(state => state.info.id);
  const { source, version, ...queryOptions } = options || {};
  return useQuery(
    [ServerStateKeysEnum.WalletBalance, userId, source ?? '', version ?? 'v1'],
    () => getBalance(version ? { source, version } : source ? { source } : undefined),
    {
      staleTime: 30_000,
      ...queryOptions,
      enabled: isLogin && (queryOptions?.enabled ?? true),
    },
  );
};
